"use client";

import { useState } from "react";
import { motion } from "framer-motion";

const WaitlistSection: React.FC = () => {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email) return;

        try {
            const res = await fetch('/api/waitlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (res.ok) {
                setSubmitted(true);
                setEmail("");
            } else {
                console.error("Failed to send");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    return (
        <section id="waitlist" className="scroll-mt-28 bg-foreground py-16 px-6">
            <motion.div
                className="max-w-3xl mx-auto text-center text-background"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, type: "spring" }}
                viewport={{ once: true }}
            >
                <h2 className="text-3xl font-bold mb-4">Join the Waitlist</h2>
                <p className="text-lg mb-6">
                    Be among the first to experience Ecovolve. The first 1000 users will unlock exclusive rewards and early access perks!
                </p>

                {!submitted ? (
                    <form
                        onSubmit={handleSubmit}
                        className="flex flex-col sm:flex-row items-center gap-4 justify-center"
                    >
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="w-full sm:w-80 px-4 py-3 rounded-lg text-foreground placeholder:text-foreground-accent focus:outline-none"
                        />
                        <button
                            type="submit"
                            className="bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded-lg font-medium transition"
                        >
                            Join Now
                        </button>
                    </form>
                ) : (
                    <div className="text-primary mt-4 font-semibold">
                        🎉 You&apos;re in! Check your inbox for a confirmation email.
                    </div>
                )}
            </motion.div>
        </section>
    );
};

export default WaitlistSection;
